import { SchoolCitySelector } from './SchoolCitySelector';
export default SchoolCitySelector;
